var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pta-admin" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-0",
        staticStyle: { "font-size": "0.75em" },
      },
      [
        _vm.users.total
          ? _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _vm.hasPermission("list-user") && _vm.users.total
                    ? _c("div", { staticClass: "table-responsive" }, [
                        _c("table", { staticClass: "table table-hover" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", { attrs: { scope: "col" } }, [
                                _vm._v(_vm._s(_vm.trans("user.first_name"))),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { scope: "col" } }, [
                                _vm._v(_vm._s(_vm.trans("user.last_name"))),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { scope: "col" } }, [
                                _vm._v(_vm._s(_vm.trans("user.email"))),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { scope: "col" } }, [
                                _vm._v("Premium"),
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { scope: "col" } }, [
                                _vm._v(_vm._s(_vm.trans("user.status"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass: "table-option",
                                  attrs: { scope: "col" },
                                },
                                [_vm._v(_vm._s(_vm.trans("general.action")))]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.users.data, function (user) {
                              return user.investors.length
                                ? _c("tr", [
                                    _c("td", {
                                      domProps: {
                                        textContent: _vm._s(
                                          user.profile.first_name
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("td", {
                                      domProps: {
                                        textContent: _vm._s(
                                          user.profile.last_name
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("td", {
                                      domProps: {
                                        textContent: _vm._s(user.email),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("td", {
                                      domProps: {
                                        textContent: _vm._s(
                                          user.profile.is_premium ? "Yes" : "No"
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      _vm._l(
                                        _vm.getUserStatus(user),
                                        function (status) {
                                          return _c(
                                            "span",
                                            {
                                              class: [
                                                "label",
                                                "label-" + status.color,
                                                "m-r-5",
                                              ],
                                            },
                                            [_vm._v(_vm._s(status.label))]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "table-option" }, [
                                      _c(
                                        "div",
                                        { staticClass: "btn-group" },
                                        [
                                          user.investors.length
                                            ? _c(
                                                "router-link",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value: "Investor List",
                                                      expression:
                                                        "'Investor List'",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "btn btn-inverse btn-sm",
                                                  attrs: {
                                                    to: `/account/users/general-partners/${user.id}/investors`,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fas fa-user-group",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ])
                                : _vm._e()
                            }),
                            0
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("pagination-record", {
                    attrs: {
                      "page-length": _vm.filterUserForm.page_length,
                      records: _vm.users,
                    },
                    on: {
                      "update:pageLength": function ($event) {
                        return _vm.$set(
                          _vm.filterUserForm,
                          "page_length",
                          $event
                        )
                      },
                      "update:page-length": function ($event) {
                        return _vm.$set(
                          _vm.filterUserForm,
                          "page_length",
                          $event
                        )
                      },
                      updateRecords: _vm.getUsers,
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "page-titles border-bottom" }, [
      _c("h3", [_vm._v("AI Recommender")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }